<script lang="ts">
  import { onMount } from "svelte";
  import BlueButton from "../BlueButton.svelte";
  import { ApiService } from "../../services/api.service";

  import FormWithLabel from "../../molecules/FormWithLabel.svelte";
  import SectionBoard from "../../molecules/SectionBoard.svelte";

  export let klass = "";

  let email = "";
  let loading = false;

  const handleEmail = (event) => {
    email = event.detail.value;
  };

  const save = async () => {
    const client = ApiService.createClient();
    loading = true;
    const { data } = await client.post("/mail/receiveSetting", {
      email,
    });
    console.log(data);
    loading = false;
  };

  onMount(async () => {
    const client = ApiService.createClient();
    const { data } = await client.get("/mail/receiveSetting?mailType=inquiry");
    console.log(data);
    if (!data.mailReceiveSetting) {
      return;
    }
    email = data.mailReceiveSetting.email;
  });
</script>

<SectionBoard {klass}>
  <h2 class="font-semibold">お問い合わせ(受信設定)</h2>

  <div class="mt-6">
    <FormWithLabel
      label="受信メールアドレス"
      placeholder="info@example.com"
      input={handleEmail}
      value={email}
    />
  </div>

  <BlueButton click={save} rounded klass="mt-4">更新する</BlueButton>
</SectionBoard>
